import { Tag } from "antd";
import {
  getBankColumn,
  getAccountNumberColumn,
  getCurrencyColumn,
  getBalanceUpdatedColumn,
  getWalletUpdatedColumn,
} from "./accountColumnHelpers";

export function headInstitutionAccountColumns() {
  return [
    getBankColumn(),
    getAccountNumberColumn(),
    getCurrencyColumn(),
    {
      title: "Төлөв",
      dataIndex: "is_active",
      key: "is_active",
      width: 140,
      align: "center",
      render: (value) =>
        value ? (
          <Tag color="green">Идэвхтэй</Tag>
        ) : (
          <Tag color="red">Идэвхгүй</Tag>
        ),
    },
    getBalanceUpdatedColumn(),
    getWalletUpdatedColumn(),
  ];
}